import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useDeleteWorkspaceInvite = ({
  message = "Workspace invite deleted successfully",
  silent = false,
}: {
  message?: string;
  silent?: boolean;
}) => {
  const userToken = useUserToken();
  const queryClient = useQueryClient();
  return useMutation(
    (id: number) =>
      fetch(`${ENDPOINTS.workspace_invites}/${id}`, {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      }),
    {
      onSuccess: async response => {
        if (response.ok) {
          if (!silent) {
            displayToast(message, ToastType.success);
          }
          queryClient.invalidateQueries([ENDPOINTS.workspace_invites]);
          queryClient.invalidateQueries(["workspace-members"]);
          return;
        }
        const data = await response.json();
        if (data?.message) {
          displayErrorToast(data.message);
          return;
        }
        displayErrorToast("Failed to delete workspace invite");
      },
    },
  );
};
